import { lazy, Suspense, useContext, useEffect, useMemo } from "react"
import InfiniteScroll from "react-infinite-scroller"
import { CardGrid, Icon } from "source/shared/components"
import { FiltersContext } from "../contexts/FiltersContext"
import { MapContext } from "../contexts/MapContext"
import { useInfiniteLoadingGroups } from "../hooks/useInfiniteLoadingGroups"
import { loadMapsLibrary } from "source/shared/googleMapsLoader"
import { Group } from "./Group"

const LazyMapDisplay = lazy(() =>
  loadMapsLibrary()
    .then(() => import("./Map"))
    .then((mod) => ({ default: mod.MapDisplay })),
)

export function GroupList() {
  const { mapIsRevealed, setHasLocations } = useContext(MapContext)
  const { setIncludeClosedGroups } = useContext(FiltersContext)
  const {
    records: groups,
    included,
    hasMore,
    loadMore,
  } = useInfiniteLoadingGroups()

  useEffect(() => {
    if (groups.length === 0) {
      setIncludeClosedGroups(true)
    }
  }, [])

  const locations = useMemo(
    () => included.filter((inc) => inc.type === "Location"),
    [included],
  )

  useEffect(() => {
    setHasLocations(locations.length > 0)
  }, [locations])

  if (groups.length === 0) return <BlankState />

  return (
    <>
      {mapIsRevealed && (
        <Suspense fallback={null}>
          <LazyMapDisplay groups={groups} locations={locations} />
        </Suspense>
      )}
      <InfiniteScroll hasMore={hasMore} loadMore={loadMore}>
        <CardGrid as="section">
          {groups.map((group) => (
            <Group key={group.id} group={group} />
          ))}
        </CardGrid>
      </InfiniteScroll>
    </>
  )
}

function BlankState() {
  const { clearFilters } = useContext(FiltersContext)

  return (
    <div className="ta-c c-tint2 fs-2">
      <Icon symbol="churchCenter#groups-o" className="mb-1" />
      <div>We can’t find any groups to match your criteria.</div>
      <div className="mt-2">
        <button
          className="compact-btn btn secondary-btn minor-btn"
          onClick={clearFilters}
        >
          Clear filters
        </button>
      </div>
    </div>
  )
}
